import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
    Button,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table,
} from "reactstrap";
import * as Yup from "yup";
import ToastDialog from "components/Common/ToastDialog";
import "./style.scss";

import { decryptedValue, isPermission } from "common/utility";
import PropTypes from "prop-types";
import { addCamData, editCamData, getCamData } from "http/fundLync/cam.helper";

// TableRow Component
const TableRow = ({ onDelete, onItemSelect, index, validation, }) => {

    const handleInputChange = (index, field, value, label) => {
        validation.setFieldValue(`keyStrenghts.${index}.${field}`, value);
    };

    return (
        <tr>
            <td data-label="key Strength" className="width-dynamic-field">
                <Input
                    type="text"
                    placeholder="Enter title"
                    name={`keyStrenghts[${index}].title`}
                    id={`keyStrenghts[${index}].title`}
                    value={validation.values.keyStrenghts[index].title}
                    onChange={(event) => {
                        handleInputChange(index, "title", event.target.value);
                    }}
                    invalid={
                        validation.touched?.keyStrenghts?.[index]?.title &&
                            validation.errors?.keyStrenghts?.[index]?.title
                            ? true
                            : false
                    }
                />
                {validation.touched.keyStrenghts?.[index]?.title &&
                    validation.errors.keyStrenghts?.[index]?.title && (
                        <FormFeedback>
                            {validation.errors.keyStrenghts?.[index]?.title}
                        </FormFeedback>
                    )}
            </td>
            <td data-label="key Strength" >
                <Input
                    type="textarea"
                    placeholder="Enter here"
                    name={`keyStrenghts[${index}].strenght`}
                    id={`keyStrenghts[${index}].strenght`}
                    rows={1}
                    className="vertical-scroll"
                    value={validation.values.keyStrenghts[index].strenght}
                    onChange={(event) => {
                        handleInputChange(index, "strenght", event.target.value);
                    }}
                    invalid={
                        validation.touched?.keyStrenghts?.[index]?.strenght &&
                            validation.errors?.keyStrenghts?.[index]?.strenght
                            ? true
                            : false
                    }
                />
                {validation.touched.keyStrenghts?.[index]?.strenght &&
                    validation.errors.keyStrenghts?.[index]?.strenght && (
                        <FormFeedback>
                            {validation.errors.keyStrenghts?.[index]?.strenght}
                        </FormFeedback>
                    )}
            </td>
            <td style={{ width: "5%" }}>
                {validation.values?.keyStrenghts?.length > 1 && (
                    <i
                        className="bx bx-x-circle text-danger"
                        onClick={() => onDelete(index)}
                        style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
                    />
                )}
            </td>
        </tr>
    );
};
const TableRowDynamic = ({ onDelete, onItemSelect, index, field, validation }) => {

    const handleInputChange = (index,field, input, value, label) => {
        validation.setFieldValue(`${field}.${index}.${input}`, value);
    };

    return (
        <tr key={index}>
            <td data-label="dynamic field" className="width-dynamic-field">
                <Input
                    type="text" 
                    placeholder="Enter title"
                    name={`${field.name}[${index}].title`}
                    id={`${field.name}[${index}].title`}
                    value={validation.values[field.name]?.[index]?.title || ""}
                    onChange={(event) => handleInputChange(index,field.name, "title", event.target.value)}
                    invalid={
                        validation.touched?.[field.name]?.[index]?.title &&
                        validation.errors?.[field.name]?.[index]?.title
                    }
                />
            </td>
            <td data-label="dynamic field">
                <Input
                    type={field.type || "textarea"} 
                    placeholder={`Enter ${field.name}`}
                    name={`${field.name}[${index}].value`}
                    id={`${field.name}[${index}].value`}
                    rows={1}
                    className="vertical-scroll"
                    value={validation.values[field.name]?.[index]?.value || ""}
                    onChange={(event) => handleInputChange(index, field.name ,"value", event.target.value)}
                    invalid={
                        validation.touched?.[field.name]?.[index]?.value &&
                        validation.errors?.[field.name]?.[index]?.value
                    }
                />
            </td>
            <td style={{ width: "5%" }}>
                {validation.values[field.name]?.length > 1 && (
                    <i
                        className="bx bx-x-circle text-danger"
                        onClick={() => onDelete(index)}
                        style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
                    />
                )}
            </td>
        </tr>
    );
};
// BorrowingProfile Component
const CamKeyStrength = forwardRef((props, ref) => {
    document.title = "Key Strength | FundLync"
    const { queryString } = props; 
    const [rows, setRows] = useState([
        {
            title: "",
            strenght: "",
        },
    ]);
    const [keyStrengthList, setKeyStrengthList] = useState([]);
    const [toastInfo, setToastInfo] = useState({ showToast: false })

    const urlParams = new URLSearchParams(window.location.search);
    const [entityId, setEntityId] = useState('');
    const [encodedId, setEncodedId] = useState('');
    const [camData, setCamData] = useState([]);
    const [dynamicFields, setDynamicFields] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    // const [dynamicFieldsFromData, setDynamicFieldsFromData] = useState([]);
    const [newField, setNewField] = useState({ name: "", type: "" });
    const encodedDealId = urlParams.get("dealId");
    const dealId = atob(encodedDealId);

    useEffect(() => {
        const userDetails = decryptedValue(localStorage.getItem("user"));
        if (userDetails.entityType === "Partner" || userDetails.entityType === "Owner") {
            setEncodedId(urlParams.get("id"))
            setEntityId(atob(encodedId))
        } else {
            setEncodedId(entityId)
            setEntityId(userDetails.entityId)
        }

    }, [entityId, encodedId])

    const addNewField = () => {
        if (newField.name && newField.type) {
            setDynamicFields([...dynamicFields, newField]);
            setNewField({ name: "", type: "" });
            toggleModal();
        }
        
    };
    const toggleModal = () => {
        setModalOpen(!modalOpen);
        if (modalOpen) {
            setNewField({
                name: '',
                type: ''
            });
        }
    };

    // useEffect(() => {
        const dynamicFieldsFromData = [
            ...(camData[0]?.keyStrength?.dynamicFieldsData
                ? Object.entries(camData[0].keyStrength?.dynamicFieldsData).map(([key, value]) => ({
                    name: key,
                    value:value,
                    fromExisting: true,
                  }))
                  : []), 
            ...dynamicFields.map((field) => ({
                ...field,
                fromExisting: false, // Indicate it's a new field
            })),
        ];

    useEffect(() => {
        const loadData = async () => {
            try {
                // Fetch the CAM data
                const response = await getCamData({ dealId });
                setCamData([response?.data[0]]);
                const data = response?.data[0]
                if (response?.status && data?.keyStrength != null) {
                    setKeyStrengthList(data?.keyStrength?.strengths);
                    setRows(data?.keyStrength?.strengths);
                } else {
                    setKeyStrengthList([]);

                }

            } catch (error) {
                console.error("Error loading data:", error);
            }
        };

        loadData();
        // checkPermissions();
    }, [entityId]);
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            keyStrenghts: rows || [
                {
                    title: "",
                    strenght: "",
                },
            ],

            ...dynamicFieldsFromData.reduce((acc, field) => {
                acc[field.name] = field.value;
                
                return acc;
            }, {})
            
        },

        validationSchema: Yup.object({
            keyStrenghts: Yup.array()
                .of(
                    Yup.object({
                        title: Yup.string().test(
                            "required-after-first",
                            "Title is required for entries after the first one",
                            function (value, context) {
                                const index = context?.options?.index;
                                return index === 0 || (value && value.trim() !== "");
                            }
                        ),
                        strenght: Yup.string().test(
                            "required-after-first",
                            "Strength is required for entries after the first one",
                            function (value, context) {
                                const index = context?.options?.index;
                                return index === 0 || (value && value.trim() !== "");
                            }
                        ),
                    })
                )
                .required("Key Strengths must be an array")
                .min(1, "At least one key strength is required"),
        }),
        onSubmit: (values) => {
            if (camData.length > 0) {
                const entity = {
                    aboutSection: camData[0]?.aboutSection,
                    directorSharehodlerList: camData[0]?.directorSharehodlerList,
                    keyStrength: {
                        strengths: values.keyStrenghts,
                        dynamicFieldsData : dynamicFieldsFromData.reduce((acc, field) => {
                            acc[field.name] = values[field.name];
                            return acc;
                        }, {})
                    },
                    finSummary: camData[0]?.finSummary,
                    debtProfile: camData[0]?.debtProfile,
                    customerSupplier: camData[0]?.customerSupplier,
                    termsheet: camData[0]?.termsheet,
                    entityId: entityId,
                    dealId: dealId,
                    id: camData[0]?.id,
                    lastVisitedStep: "financial-summary" || null,
                }
                editCamData(entity)
                    .then((response) => {
                        if (response.code == 201 && response.status) {
                            setToastInfo({
                                message: "Cam Data Updated",
                                showToast: true,
                                role: "success",
                            });
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                const entity = {
                    aboutSection: camData[0]?.aboutSection,
                    directorSharehodlerList: camData[0]?.directorSharehodlerList,
                    keyStrength: values.keyStrenghts,
                    finSummary: camData[0]?.finSummary,
                    debtProfile: camData[0]?.debtProfile,
                    customerSupplier: camData[0]?.customerSupplier,
                    termsheet: camData[0]?.termsheet,
                    entityId: entityId,
                    dealId: dealId,
                    id: camData[0]?.id,
                    lastVisitedStep: "financial-summary" || null,
                };
                addCamData(entity)
                    .then((response) => {
                        if (response.code == 201 && response.status) {
                            setToastInfo({
                                message: "Cam Data Saved",
                                showToast: true,
                                role: "success",
                            });
                        } else {
                            const { message } = response;
                            setToastInfo({
                                message: message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    });
    useImperativeHandle(ref, () => ({
        handleSubmit: () => validation.handleSubmit(),
        toggleModal: () => toggleModal(),
        getValidationStatus: () =>
            validation.validateForm().then((errors) => Object.keys(errors).length === 0),
    }));

    const handleDelete = (rowIndex) => {
        validation.values.keyStrenghts.splice(rowIndex, 1);
        validation.validateForm();
    };
    
    const handleDeleteDynamic = (fieldName, rowIndex) => {
        const fieldArray = validation.values[fieldName];
        
        if (fieldArray) {
            fieldArray.splice(rowIndex, 1);
            validation.validateForm();
        } else {
            console.error(`Field "${fieldName}" not found in validation.values.`);
        }
    };
    
    
    const handleItemSelect = (data, value) => {
        data.type = value;
        validation.setFieldValue("type", value);
    };
    const removeField = (fieldName) => {
        // Remove field from dynamic fields
        setDynamicFields((prevFields) =>
            prevFields.filter((field) => field.name !== fieldName)
        );
        setCamData((prevData) => {
            if (prevData.length > 0) {
                const updatedDynamicFieldsData = { ...prevData[0]?.keyStrength?.dynamicFieldsData };
                delete updatedDynamicFieldsData[fieldName];
                return [
                    {
                        ...prevData[0],
                        keyStrength: {
                            ...prevData[0]?.keyStrength,
                            dynamicFieldsData: updatedDynamicFieldsData,
                        },
                    },
                ];
            }
            return prevData;
        });
        validation.setFieldValue(fieldName, undefined);
        validation.setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[fieldName];
            return updatedErrors;
        });
    };
    const handleAddRow = (fieldName, arrayHelpers ) => {
        const targetField = dynamicFieldsFromData.find(field => field.name === fieldName);
        if (targetField) {
            arrayHelpers.push({
                type: targetField?.type,
                title: "",
                value: ""
            });
        } else {
            console.error(`Field "${fieldName}" not found in dynamicFieldsFromData`);
        }
    };
    
    return (
        <React.Fragment>
            <FormikProvider value={validation}>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <Row>
                        <Col sm="12">
                            <div className="table-responsive react-table">
                                <Table
                                    Table
                                    striped
                                    bordered
                                    hover
                                    className="responsive-table"
                                    style={{ width: "100%", backgroundColor: "white" }}
                                >
                                    <thead className="d-md-table-header-group">
                                        <tr>
                                            <th>Title</th>
                                            <th>Key Strength</th>

                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <FieldArray
                                            name="keyStrenghts"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {validation.values.keyStrenghts.map(
                                                        (lender, index) => (
                                                            <TableRow
                                                                key={lender.id}
                                                                onDelete={handleDelete}
                                                                onItemSelect={handleItemSelect}
                                                                index={index}
                                                                validation={validation}
                                                            />
                                                        )
                                                    )}
                                                    <tr>
                                                        <td colSpan={3}>
                                                            <span
                                                                className="text-success"
                                                                style={{ cursor: "pointer" }}
                                                                onKeyUp={() => { }}
                                                                onClick={() => {
                                                                    arrayHelpers.push({
                                                                        title: "",
                                                                        strenght: "",
                                                                    });
                                                                }}
                                                            >
                                                                <i className="mdi mdi-plus me-1" /> Add
                                                                Key Strength
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        />
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                    {dynamicFieldsFromData.length > 0 && (
                        <Row>
                            <Col sm="12">
                                <div className="table-responsive react-table">
                                    <Table
                                        Table
                                        striped
                                        bordered
                                        hover
                                        className="responsive-table"
                                        style={{ width: "100%", backgroundColor: "white" }}
                                    >
                                        <thead className="d-md-table-header-group">
                                            <tr>
                                                <th>Title</th>
                                                <th>value</th>

                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {dynamicFieldsFromData.map((field, index) => (
                                                <FieldArray
                                                    name={field.name}
                                                    key={field.name} 
                                                    render={(arrayHelpers) => (
                                                        <>
                                                            <React.Fragment key={field.id}>
                                                            {validation.values[field.name]?.map((item, rowIndex) => (
                                                                <TableRowDynamic
                                                                    key={rowIndex} // Ensure a unique key for each row
                                                                    onDelete={(rowIdx) => handleDeleteDynamic(field.name, rowIdx)} // Dynamic delete
                                                                    onItemSelect={handleItemSelect}
                                                                    index={rowIndex}
                                                                    field={field}
                                                                    validation={validation}
                                                                />
                                                            ))}
                                                                <tr>
                                                                    <td colSpan={3}>
                                                                        <span
                                                                            className="text-success"
                                                                            style={{ cursor: "pointer" }}
                                                                            onKeyUp={() => { }}
                                                                            onClick={() => {
                                                                                const dynamicFieldName = field.name; // Access field.name here
                                                                                handleAddRow(dynamicFieldName, arrayHelpers); // Call function to add row
                                                                            }}
                                                                        >
                                                                            <i className="mdi mdi-plus me-1" /> Add {field.name}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment></>
                                                    )}
                                                />
                                            ))}

                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Form>
            </FormikProvider>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
            <Modal autoFocus={true} centered isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Add New Field</ModalHeader>
                <ModalBody>
                    <Label>Field Name</Label>
                    <Input
                        type="text"
                        placeholder="Enter Field Name"
                        value={newField.name}
                        onChange={(e) => setNewField({ ...newField, name: e.target.value })}
                    />
                    <Label className="mt-3">Field Type</Label>
                    <Input
                        type="select"
                        value={newField.type}
                        onChange={(e) => setNewField({ ...newField, type: e.target.value })}
                    >
                        <option value="">Select Type</option>
                        <option value="text">Text Field</option>
                        <option value="textarea">Textarea</option>
                    </Input>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn btn-success save-customer" onClick={addNewField}>
                        Add Field
                    </Button>
                    <button type="button" className="btn btn-outline-secondary save-customer me-2" onClick={toggleModal}>
                        Cancel
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
});

CamKeyStrength.propTypes = {
    history: PropTypes.object,
};

CamKeyStrength.displayName = "keyStrength"
export default CamKeyStrength;

